// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"125":"component---src-pages-404-js","293":"component---src-pages-index-js"}[chunkId] || chunkId) + "-" + {"125":"753df6501fac9c28ef6c","293":"4818c1f87b528cdc53ce","454":"2fc9c25d9027fac35a3e"}[chunkId] + ".js";
};